module.exports = __webpack_public_path__ + "h5/img/corporate-culture.e4d33854.jpg";